<div class="session-plan-area col-sm-12 h-100 p-2 readOnlyFormPlanner">
  <div class="row full-width leftPanelTop card  p-0 mb-2 bg-black " *ngIf="activeSmartChecklist == ''">
    <div class="row strict h-100">
      <ul class="nav nav-tabs planner-nav-tabs">
        <li [ngClass]="{ 'active':activeProjectTab==='sprint'}">
          <a data-toggle="tab" class="textClrWhite" (click)="shiftProjectTabs('sprint');">
            <div class="align_left">
              {{ 'planner.projectTaskTab' | translate }}
            </div>
            <div class="align_left">
              ({{(modelData.tasks|sprintTab:mytasksTabFilter:filterTypeCountProject)}})
            </div>
          </a>
        </li>
        <li [ngClass]="{ 'active':activeProjectTab==='myTasks'}">
          <a data-toggle="tab" id="myTasksClick" class="textClrWhite" (click)="shiftProjectTabs('myTasks')">
            <div class="align_left">
              {{ 'planner.myTasksTab' | translate }}
            </div>
            <div class="align_left">
              ({{(modelData.tasks|mytasksTab:mytasksTabFilter:filterTypeCount)}})
            </div>
          </a>
        </li>
        <li [ngClass]="{ 'active':activeProjectTab==='session'}">
          <a data-toggle="tab" class="textClrWhite" (click)="shiftProjectTabs('session')">
            <div class="align_left">
              {{ 'planner.sessionTaskTab' | translate }}
            </div>
            <div class="align_left">
              ({{(modelData.tasks|sessionTab:sessionTabFilter:filterTypeCount)}})
            </div>
          </a>
        </li>
        <li [ngClass]="{ 'active':activeProjectTab==='history'}">
          <a data-toggle="tab" class="textClrWhite" (click)="shiftProjectTabs('history');getHistoryArray()">
            <div class="align_left">
              {{ 'planner.historyTaskTab' | translate }}</div>
            <div class="align_left">
              ({{sessionHistoryArray.length}})
            </div>
          </a>
        </li>
      </ul>
      <div class="tab-content planner-nav-tab-content-height">
        <div [ngClass]="{ 'active':activeProjectTab==='sprint'}" class="tab-pane fade in " ui-sortable>
          <div
            class="ui-sortable-item ui-sortable-item-planner row padding-vertical p-0 border-none mapperReadOnly labelReadOnly">
            <!-- <span id="EUT-9b62-b0a1-8f38-e09b-6eb8a7c348b1storytasks" >-</span>
            <span id="EUT-5ea1-820e-2499-6a0d-71ea8a73547bstorytasks" >-</span> -->
            <section class="accordion" *ngFor="let sprintName of projectNamesArrayAll; let tabIndex = index">
              <input type="checkbox" name="{{sprintName.sprintName}}" id="{{sprintName.sprintID}}alltasks">
              <h2 class="handle">
                <label class="{{sprintName.sprintID}}alltasksPlusLabel" for="{{sprintName.sprintID}}alltasks"
                  (click)="setToggleIcon(sprintName.sprintID+'alltasks', true, 'Module');">
                  <span>
                    <fa-icon [icon]="faPlus" class="fa icon"></fa-icon>
                  </span>
                  {{sprintName.sprintName}}
                  <!-- ({{(modelData.tasks|sprintName:mytasksTabFilter:filterTypeCountProject:{sprintName:sprintName.sprintName})}}) -->
                </label>
                <label class="{{sprintName.sprintID}}alltasksMinusLabel displayNone"
                  for="{{sprintName.sprintID}}alltasks"
                  (click)="setToggleIcon(sprintName.sprintID+'alltasks', false, 'Module')">
                  <span>
                    <fa-icon [icon]="faMinus" class="fa icon"></fa-icon>
                  </span>
                  {{sprintName.sprintName}}
                  <!-- ({{(modelData.tasks|sprintName:mytasksTabFilter:filterTypeCountProject:{sprintName:sprintName.sprintName})}}) -->
                </label>
              </h2>

              <div class="content myTasksContent pb-0 pt-0">
                <section class="accordion accordion1"
                  *ngFor="let userStory of userStoriesProjectListAll; let tabIndex = index"
                  [ngClass]="{ 'displayNone':userStory.moduleName != sprintName.sprintName}">
                  <input type="checkbox" name="{{userStory.userStoryID}}{{sprintName.sprintID}}"
                    id="{{userStory.userStoryID}}{{sprintName.sprintID}}storytasks">
                  <h2 class="handle ml-3">
                    <label class="{{userStory.userStoryID}}{{sprintName.sprintID}}storytasksPlusLabel cursorArrow"
                      for="{{userStory.userStoryID}}{{sprintName.sprintID}}storytasks"
                      (click)="getProjectTaskListByEUT(userStory.entity_Id,userStory,userStory.userStoryID+sprintName.sprintID+'storytasks')">
                      <span>
                        <fa-icon [icon]="faPlus" class="fa icon"></fa-icon>
                      </span>
                      {{userStory.entity_desc}}
                      ({{(modelData.tasks|sprintName:mytasksTabFilter:filterTypeCountProject:{sprintName:sprintName.sprintName}:userStory)}})
                    </label>
                    <!-- setToggleIcon(userStory.userStoryID+sprintName.sprintID+'storytasks', false) -->
                    <label
                      class="{{userStory.userStoryID}}{{sprintName.sprintID}}storytasksMinusLabel displayNone cursorArrow"
                      for="{{userStory.userStoryID}}{{sprintName.sprintID}}storytasks"
                      (click)="setToggleIcon(userStory.userStoryID+sprintName.sprintID+'storytasks', false, 'EUT')">
                      <span>
                        <fa-icon [icon]="faMinus" class="fa icon"></fa-icon>
                      </span>
                      {{userStory.entity_desc}}
                      ({{(modelData.tasks|sprintName:mytasksTabFilter:filterTypeCountProject:{sprintName:sprintName.sprintName}:userStory)}})
                    </label>
                  </h2>
                  <div id="{{userStory.entity_Id}}" class="content myTasksContent pb-0 pt-0 ml-3">
                    <!-- <span id="{{userStory.entity_Id}}" >--</span> -->
                    <span class="cursorArrow" [innerHTML]="listForProjectTasks">---</span>
                    <!-- <ul class="listStyleNone">
                      <li *ngFor="let task of modelData.tasks; let tabIndex = index"
                        [ngClass]="{ 'displayNone':(task.entity_desc != userStory.entity_desc) && (task.status != 2 || task.status != 1)}">
                        <div class="row strict"
                          *ngIf="(task.moduleName == sprintName.sprintName && task.assignedto == '' && task.primaryentity_Id == '') && (task.status == 2 || task.status == 1)">
                          <div class="col-xs-11 col-sm-10 col-md-10 col-lg-11 col-xl-11 planner-mytasks-list-div-width">
                            <label class="planner-label form-control transparent"
                              [textContent]="task.task_desc"></label>
                          </div>
                        </div>
                      </li>
                      <li *ngFor="let task of modelData.tasks; let tabIndex = index"
                        [ngClass]="{ 'displayNone':(task.primaryentity_Id != userStory.entity_Id) }">
                        <div class="row strict"
                          *ngIf="(task.primaryentity_Id == userStory.entity_Id) && (task.status == 2 || task.status == 1)">
                          <div class="col-xs-11 col-sm-10 col-md-10 col-lg-11 col-xl-11 planner-mytasks-list-div-width">
                            <label class="planner-label form-control transparent">{{getTaskDesc(task)}}</label>
                          </div>
                        </div>
                      </li>
                    </ul> -->
                  </div>
                </section>
              </div>
            </section>

            <div class="row strict"
              *ngIf="((modelData.tasks|sprintTab:mytasksTabFilter:filterTypeCount > 0) ||(modelData.tasks.length <= 0) )">
              <div class="col-xs-12">
                <div class="col-xs-12 alert alert-warning text-flow mb-0">
                  <strong>{{ 'planner.emptyTaskListSprint' | translate }}</strong>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div [ngClass]="{ 'active':activeProjectTab==='myTasks'}" class="tab-pane fade in" ui-sortable>
          <div
            class="ui-sortable-item ui-sortable-item-planner row padding-vertical p-0 border-none mapperReadOnly labelReadOnly">
            <div class="dropdown">
              <button class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                type="button" data-toggle="dropdown">
                <div class="row strict">
                  <div class="col-xs-10 span-on-button ">
                    {{filter}}
                  </div>
                  <div class="col-xs-1 col-xs-offset-1 pull-right ">
                    <span class="caret"></span>
                  </div>
                </div>

              </button>
              <ul class="dropdown-menu fit-size w-150">
                <li *ngFor="let filter of tasksFilterArray;" (click)="updatetasksFilter(filter)">
                  <a class="dropdown-item">{{filter}}</a>
                </li>
              </ul>
            </div>
            <span *ngIf="taskHistory == false">
              <section class="accordion" *ngFor="let sprintName of sprintNamesArrayAll; let tabIndex = index">
                <input type="checkbox" name="{{sprintName.sprintName}}" id="{{sprintName.sprintID}}mytasks">
                <h2 class="handle">
                  <label class="{{sprintName.sprintID}}mytasksPlusLabel" for="{{sprintName.sprintID}}mytasks"
                    (click)="setToggleIconMytasks(sprintName.sprintID+'mytasks', true)">
                    <span>
                      <fa-icon [icon]="faPlus" class="fa icon"></fa-icon>
                    </span>
                    {{sprintName.sprintName}}
                    <!-- ({{(modelData.tasks|sprintName:mytasksTabFilter:filterTypeCount:{sprintName:sprintName.sprintName})}}) -->
                  </label>
                  <label class="{{sprintName.sprintID}}mytasksMinusLabel displayNone"
                    for="{{sprintName.sprintID}}mytasks"
                    (click)="setToggleIconMytasks(sprintName.sprintID+'mytasks', false)">
                    <span>
                      <fa-icon [icon]="faMinus" class="fa icon"></fa-icon>
                    </span>
                    {{sprintName.sprintName}}
                    <!-- ({{(modelData.tasks|sprintName:mytasksTabFilter:filterTypeCount:{sprintName:sprintName.sprintName})}}) -->
                  </label>
                </h2>
                <div class="content myTasksContent pb-0 pt-0">
                  <section class="accordion accordion1"
                    *ngFor="let userStory of userStoriesListAll; let tabIndex = index"
                    [ngClass]="{ 'displayNone':userStory.moduleName != sprintName.sprintName}">
                    <input type="checkbox" name="{{userStory.userStoryID}}{{sprintName.sprintID}}"
                      id="{{userStory.userStoryID}}{{sprintName.sprintID}}mytasks">
                    <h2 class="handle ml-3">
                      <label class="{{userStory.userStoryID}}{{sprintName.sprintID}}mytasksPlusLabel"
                        for="{{userStory.userStoryID}}{{sprintName.sprintID}}mytasks"
                        (click)="setToggleIconMytasks(userStory.userStoryID+sprintName.sprintID+'mytasks', true)">
                        <span>
                          <fa-icon [icon]="faPlus" class="fa icon"></fa-icon>
                        </span>
                        {{userStory.entity_desc}}
                        ({{(modelData.tasks|sprintName:mytasksTabFilter:filterTypeCount:{sprintName:sprintName.sprintName}:userStory)}})
                      </label>
                      <label class="{{userStory.userStoryID}}{{sprintName.sprintID}}mytasksMinusLabel displayNone"
                        for="{{userStory.userStoryID}}{{sprintName.sprintID}}mytasks"
                        (click)="setToggleIconMytasks(userStory.userStoryID+sprintName.sprintID+'mytasks', false)">
                        <span>
                          <fa-icon [icon]="faMinus" class="fa icon"></fa-icon>
                        </span>
                        {{userStory.entity_desc}}
                        ({{(modelData.tasks|sprintName:mytasksTabFilter:filterTypeCount:{sprintName:sprintName.sprintName}:userStory)}})
                      </label>
                    </h2>
                    <div class="content myTasksContent pb-0 pt-0 ml-3">
                      <!-- <span [innerHTML]="listForMyTasks">---</span> -->
                      <ul class="listStyleNone">
                        <li *ngFor="let task of modelData.tasks; let tabIndex = index"
                          [ngClass]="{ 'displayNone':(task.entity_desc != userStory.entity_desc) && (task.status != 2 || task.status != 1) && (task.activity.type == 'RI')}">
                          <div class="row strict"
                            *ngIf="(task.moduleName == sprintName.sprintName && task.assignedto == userId && (userStory.entity_Id == task.primaryentity_Id || userStory.entity_Id == task.entity_Id)) && (task.status == 2 || task.status == 1) && (task.activity.type != 'RI')">
                            <div class="col-xs-1 col-sm-2 col-md-2 col-lg-1 col-xl-1 task-status width-30px"
                              (click)="myTaskAllocate(task);updateTasksTable()">
                              <fa-icon [icon]="faCircle" *ngIf="task.status=='1'"
                                class="far icon form-control strict transparent planner-icon icon-white mapperReadOnly height10px">
                              </fa-icon>
                              <fa-icon [icon]="faArrowAltCircleRight" *ngIf="task.status=='2'"
                                class="far icon form-control strict transparent planner-icon icon-white mapperReadOnly height10px">
                              </fa-icon>
                            </div>
                            <div
                              class="col-xs-11 col-sm-10 col-md-10 col-lg-11 col-xl-11 planner-mytasks-list-div-width">
                              <label class="planner-label form-control transparent"
                                (click)="openTaskTool(task)">{{getTaskDesc(task)}}</label>
                            </div>
                          </div>
                        </li>
                        <li *ngFor="let task of modelData.tasks; let tabIndex = index"
                          [ngClass]="{ 'displayNone':(task.activity.type != 'RI') }">
                          <div class="row strict"
                            *ngIf="(task.primaryentity_Id == userStory.entity_Id) && (task.status == 2 || task.status == 1)">
                            <div class="col-xs-1 col-sm-2 col-md-2 col-lg-1 col-xl-1 task-status width-30px"
                              (click)="myTaskAllocate(task);updateTasksTable()">
                              <fa-icon [icon]="faCircle" *ngIf="task.status=='1'"
                                class="far icon form-control strict transparent planner-icon icon-white mapperReadOnly height10px">
                              </fa-icon>
                              <fa-icon [icon]="faArrowAltCircleRight" *ngIf="task.status=='2'"
                                class="far icon form-control strict transparent planner-icon icon-white mapperReadOnly height10px">
                              </fa-icon>
                            </div>
                            <div
                              class="col-xs-11 col-sm-10 col-md-10 col-lg-11 col-xl-11 planner-mytasks-list-div-width">
                              <label class="planner-label form-control transparent"
                                (click)="openTaskTool(task)">{{getTaskDesc(task)}}</label>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </section>
                </div>
              </section>
            </span>
            <span *ngIf="taskHistory == true">
              <section class="accordion" *ngFor="let sprintName of sprintNamesArrayCompleteAll; let tabIndex = index">
                <input type="checkbox" name="{{sprintName.sprintName}}" id="{{sprintName.sprintID}}mytaskscomplete">
                <h2 class="handle">
                  <label class="{{sprintName.sprintID}}mytaskscompletePlusLabel"
                    for="{{sprintName.sprintID}}mytaskscomplete"
                    (click)="setToggleIconCompleted(sprintName.sprintID+'mytaskscomplete', true)">
                    <span>
                      <fa-icon [icon]="faPlus" class="fa icon"></fa-icon>
                    </span>
                    {{sprintName.sprintName}}
                    <!-- ({{(modelData.tasks|sprintName:mytasksTabFilter:filterTypeCountCompleted:{sprintName:sprintName.sprintName})}}) -->
                  </label>
                  <label class="{{sprintName.sprintID}}mytaskscompleteMinusLabel displayNone"
                    for="{{sprintName.sprintID}}mytaskscomplete"
                    (click)="setToggleIconCompleted(sprintName.sprintID+'mytaskscomplete', false)">
                    <span>
                      <fa-icon [icon]="faMinus" class="fa icon"></fa-icon>
                    </span>
                    {{sprintName.sprintName}}
                    <!-- ({{(modelData.tasks|sprintName:mytasksTabFilter:filterTypeCountCompleted:{sprintName:sprintName.sprintName})}}) -->
                  </label>
                </h2>
                <div class="content myTasksContent pb-0 pt-0">
                  <section class="accordion accordion1"
                    *ngFor="let userStory of userStoriesListCompleteAll; let tabIndex = index"
                    [ngClass]="{ 'displayNone':userStory.moduleName != sprintName.sprintName}">
                    <input type="checkbox" name="{{userStory.userStoryID}}{{sprintName.sprintID}}"
                      id="{{userStory.userStoryID}}{{sprintName.sprintID}}storytaskscomplete">
                    <h2 class="handle ml-3">
                      <label class="{{userStory.userStoryID}}{{sprintName.sprintID}}storytaskscompletePlusLabel"
                        for="{{userStory.userStoryID}}{{sprintName.sprintID}}storytaskscomplete"
                        (click)="setToggleIconCompleted(userStory.userStoryID+sprintName.sprintID+'storytaskscomplete', true)">
                        <span>
                          <fa-icon [icon]="faPlus" class="fa icon"></fa-icon>
                        </span>
                        {{userStory.entity_desc}}
                        ({{(modelData.tasks|sprintName:mytasksTabFilter:filterTypeCountCompleted:{sprintName:sprintName.sprintName}:userStory)}})
                      </label>
                      <label
                        class="{{userStory.userStoryID}}{{sprintName.sprintID}}storytaskscompleteMinusLabel displayNone"
                        for="{{userStory.userStoryID}}{{sprintName.sprintID}}storytaskscomplete"
                        (click)="setToggleIconCompleted(userStory.userStoryID+sprintName.sprintID+'storytaskscomplete', false)">
                        <span>
                          <fa-icon [icon]="faMinus" class="fa icon"></fa-icon>
                        </span>
                        {{userStory.entity_desc}}
                        ({{(modelData.tasks|sprintName:mytasksTabFilter:filterTypeCountCompleted:{sprintName:sprintName.sprintName}:userStory)}})
                      </label>
                    </h2>
                    <div class="content myTasksContent pb-0 pt-0 ml-3">
                      <ul class="listStyleNone">
                        <li *ngFor="let task of modelData.tasks; let tabIndex = index"
                          [ngClass]="{ 'displayNone':(task.task_combine_id != userStory.task_combine_id) && task.status != 3}">
                          <div class="row strict"
                            *ngIf="(task.moduleName == sprintName.sprintName && task.assignedto == userId) && task.status == 3 ">
                            <div class="col-xs-1 col-sm-2 col-md-2 col-lg-1 col-xl-1 task-status width-30px"
                              (click)="myTaskreAllocate(task);updateTasksTable()">
                              <fa-icon [icon]="faCheckCircle" *ngIf="task.completed"
                                class="fas icon form-control strict transparent planner-icon iconMargin icon-white mapperReadOnly height10px">
                              </fa-icon>
                            </div>
                            <div
                              class="col-xs-11 col-sm-10 col-md-10 col-lg-11 col-xl-11 planner-mytasks-list-div-width">
                              <label class="planner-label form-control transparent"
                                (click)="openTaskTool(task)">{{getTaskDesc(task)}}</label>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </section>
                </div>
              </section>
            </span>
            <div class="row strict" *ngIf="sprintNamesArrayAll.length <= 0 && taskHistory == false">
              <div class="col-xs-12">
                <div class="col-xs-12 alert alert-warning text-flow mb-0">
                  <strong>{{ 'planner.emptyTaskListSprint' | translate }}</strong>
                </div>
              </div>
            </div>
            <div class="row strict" *ngIf="sprintNamesArrayCompleteAll.length <= 0 && taskHistory == true">
              <div class="col-xs-12">
                <div class="col-xs-12 alert alert-warning text-flow mb-0">
                  <strong>{{ 'planner.emptyTaskListSprint' | translate }}</strong>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div [ngClass]="{ 'active':activeProjectTab==='session'}" class="tab-pane fade in" ui-sortable>
          <div
            class="ui-sortable-item ui-sortable-item-planner row padding-vertical p-0 border-none mapperReadOnly labelReadOnly">
            <section class="accordion" *ngFor="let sprintName of sessionModuleNamesArrayAll; let tabIndex = index">
              <input type="checkbox" name="{{sprintName.sprintName}}" id="{{sprintName.sprintID}}session">
              <h2 class="handle">
                <label class="{{sprintName.sprintID}}sessionPlusLabel" for="{{sprintName.sprintID}}session"
                  (click)="setToggleIconSession(sprintName.sprintID+'session', true)">
                  <span>
                    <fa-icon [icon]="faPlus" class="fa icon"></fa-icon>
                  </span>
                  {{sprintName.sprintName}}
                  <!-- ({{(modelData.tasks|sprintName:sessionTabFilter:filterTypeCountSession:{sprintName:sprintName.sprintName})}}) -->
                </label>
                <label class="{{sprintName.sprintID}}sessionMinusLabel displayNone" for="{{sprintName.sprintID}}session"
                  (click)="setToggleIconSession(sprintName.sprintID+'session', false)">
                  <span>
                    <fa-icon [icon]="faMinus" class="fa icon"></fa-icon>
                  </span>
                  {{sprintName.sprintName}}
                  <!-- ({{(modelData.tasks|sprintName:sessionTabFilter:filterTypeCountSession:{sprintName:sprintName.sprintName})}}) -->
                </label>
              </h2>
              <div class="content myTasksContent pb-0 pt-0">
                <section class="accordion accordion1"
                  *ngFor="let userStory of moduleTasksListSessionAll; let tabIndex = index"
                  [ngClass]="{ 'displayNone':userStory.moduleName != sprintName.sprintName}">
                  <input type="checkbox" name="{{userStory.userStoryID}}{{sprintName.sprintID}}"
                    id="{{userStory.userStoryID}}{{sprintName.sprintID}}sessionstorytasks">
                  <h2 class="handle ml-3">
                    <label class="{{userStory.userStoryID}}{{sprintName.sprintID}}sessionstorytasksPlusLabel"
                      for="{{userStory.userStoryID}}{{sprintName.sprintID}}sessionstorytasks"
                      (click)="setToggleIconSession(userStory.userStoryID+sprintName.sprintID+'sessionstorytasks', true)">
                      <span>
                        <fa-icon [icon]="faPlus" class="fa icon"></fa-icon>
                      </span>
                      {{userStory.entity_desc}}
                      ({{(modelData.tasks|sprintName:sessionTabFilter:filterTypeCountSession:{sprintName:sprintName.sprintName}:userStory)}})
                    </label>
                    <label
                      class="{{userStory.userStoryID}}{{sprintName.sprintID}}sessionstorytasksMinusLabel displayNone"
                      for="{{userStory.userStoryID}}{{sprintName.sprintID}}sessionstorytasks"
                      (click)="setToggleIconSession(userStory.userStoryID+sprintName.sprintID+'sessionstorytasks', false)">
                      <span>
                        <fa-icon [icon]="faMinus" class="fa icon"></fa-icon>
                      </span>
                      {{userStory.entity_desc}}
                      ({{(modelData.tasks|sprintName:sessionTabFilter:filterTypeCountSession:{sprintName:sprintName.sprintName}:userStory)}})
                    </label>
                  </h2>
                  <div class="content myTasksContent pb-0 pt-0 ml-3">
                    <ul class="listStyleNone">
                      <li *ngFor="let task of modelData.tasks; let tabIndex = index"
                        [ngClass]="{ 'displayNone':(task.entity_desc != userStory.entity_desc)}">
                        <div class="row strict"
                          *ngIf="(task.moduleName == sprintName.sprintName && task.assignedto == userId) && task.status == 2 ">
                          <div class="col-xs-1 col-sm-2 col-md-2 col-lg-1 col-xl-1 task-status width-30px"
                            (click)="finishTask(task);updateTasksTable()">
                            <fa-icon [icon]="faCircle" *ngIf="!task.completed"
                              class="far fa-circle icon form-control strict transparent planner-icon iconMargin icon-white mapperReadOnly height10px">
                            </fa-icon>
                            <fa-icon [icon]="faCheckCircle" *ngIf="task.completed"
                              class="fas icon form-control strict transparent planner-icon iconMargin icon-white mapperReadOnly height10px">
                            </fa-icon>
                          </div>
                          <div class="col-xs-11 col-sm-10 col-md-10 col-lg-11 col-xl-11 planner-mytasks-list-div-width">
                            <label class="planner-label form-control transparent"
                              (click)="openTaskTool(task)">{{getTaskDesc(task)}}</label>
                          </div>
                        </div>
                      </li>
                      <li *ngFor="let task of modelData.tasks; let tabIndex = index"
                        [ngClass]="{ 'displayNone':(task.activity.type != 'RI') }">
                        <div class="row strict"
                          *ngIf="(task.primaryentity_Id == userStory.entity_Id) && (task.status == 2)">
                          <div class="col-xs-1 col-sm-2 col-md-2 col-lg-1 col-xl-1 task-status width-30px"
                            (click)="finishTask(task);updateTasksTable()">
                            <fa-icon [icon]="faCircle" *ngIf="!task.completed"
                              class="far fa-circle icon form-control strict transparent planner-icon iconMargin icon-white mapperReadOnly height10px">
                            </fa-icon>
                            <fa-icon [icon]="faCheckCircle" *ngIf="task.completed"
                              class="fas icon form-control strict transparent planner-icon iconMargin icon-white mapperReadOnly height10px">
                            </fa-icon>
                          </div>
                          <div class="col-xs-11 col-sm-10 col-md-10 col-lg-11 col-xl-11 planner-mytasks-list-div-width">
                            <label class="planner-label form-control transparent"
                              (click)="openTaskTool(task)">{{getTaskDesc(task)}}</label>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </section>
              </div>
            </section>
            <div class="row strict" *ngIf="sessionModuleNamesArrayAll.length <= 0">
              <div class="col-xs-12">
                <div class="col-xs-12 alert alert-warning text-flow mb-0 cursorArrow">
                  <strong>{{ 'planner.emptyTaskListSession' | translate }}</strong>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="ui-sortable-item ui-sortable-item-planner row padding-vertical mapperReadOnly labelReadOnly"
            *ngFor="let task of modelData.tasks|sessionTab:sessionTabFilter:filterTypeList; let tabIndex = index"
            [ngClass]="{ 'displayNone':(task.history== false && task.assignedto != userId && task.status!= 2)}">
            <div class="col-xs-1 col-sm-2 col-md-2 col-lg-1 col-xl-1 task-status width-30px"
              *ngIf="task.history== false && task.status== 2&& task.assignedto == userId"
              (click)="finishTask(task);updateTasksTable()">
              <fa-icon [icon]="faCircle" *ngIf="!task.completed"
                class="far fa-circle icon form-control strict transparent planner-icon iconMargin icon-white mapperReadOnly height10px">
              </fa-icon>
              <fa-icon [icon]="faCheckCircle" *ngIf="task.completed"
                class="fas icon form-control strict transparent planner-icon iconMargin icon-white mapperReadOnly height10px">
              </fa-icon>
            </div>
            <div *ngIf="task.history== false && task.status== 2&& task.assignedto == userId"
              class="col-xs-11 col-sm-10 col-md-10 col-lg-11 col-xl-11 planner-mytasks-list-div-width">
              <label class="planner-label form-control transparent" [textContent]="task.task_desc"
                (click)="openTaskTool(task)"></label>
            </div>
          </div> -->
          <!-- <div class="row strict"
            *ngIf="(((modelData.tasks|sessionTab:sessionTabFilter:filterTypeCount) <= 0) ||(modelData.tasks.length <= 0) )">
            <div class="col-xs-12 alert alert-warning text-flow mb-0">
              <strong>
                {{ 'planner.emptyTaskListSession' | translate }}
              </strong>
            </div>
          </div> -->
        </div>

        <div [ngClass]="{ 'active':activeProjectTab==='history'}" class="tab-pane fade in" ui-sortable>
          <div class="ui-sortable-item ui-sortable-item-planner row padding-vertical p-0 border-none">
            <section class="accordion" *ngFor="let task of sessionHistoryArray; let tabIndex = index">
              <input type="checkbox" name="{{task._id}}" id="{{task._id}}">
              <h2 class="handle">
                <label for="{{task._id}}">
                  {{task.createdTime | date:'medium'}}
                </label>
              </h2>
              <div class="content">
                <ul class="listStyleNone text-color-white cursorArrow"
                  *ngFor="let taskdesc of task.history; let tabIndex = index">
                  <li>
                    {{taskdesc.desc}}
                  </li>
                </ul>
              </div>
            </section>
            <div class="row strict" *ngIf="sessionHistoryArray.length <= 0">
              <div class="col-xs-12">
                <div class="col-xs-12 alert alert-warning text-flow mb-0">
                  <strong>{{ 'planner.emptyTaskListHistory' | translate }}</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div *ngIf="loader == true" >
          <div class="loader-container" >
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden" style="color: lightyellow !important;" ><fa-icon class="fa fa-spin icon-white" [icon]="faSpinner"></fa-icon> Loading tasks...</span>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>

  <div class="row full-width card h-100 p-0 mb-2 cursorArrow"
    style="background-color: #ffffcc !important; overflow-x: auto;" *ngIf="activeSmartChecklist == 'ls'">
    <ul>
      <h4>Landscaper - Smart Checks</h4>
      <ol class="listStyleNone pl-2 overflowY">
        <li>1. know WHO :</li>
        <ol class="listStyleNone pl-4">
          <li>- Who are the potential users? Any new users serviced in this release?</li>
          <li>- Jot them down as (new) PERSONA.</li>
        </ol>
        <li>2. know WHAT:</li>
        <ol class="listStyleNone pl-4">
          <li>- What features/requirements/flows are slated in this release?</li>
          <li>- Are these NEW, FIXES or ENHANCEMENTS?</li>
          <li>- Jot them down, slot into modules as needed.
            (Note SYSTEM is the default module where an entity is slotted)</li>
        </ol>
        <li>3. know WHAT-FOR :</li>
        <ol class="listStyleNone pl-4">
          <li>- What key attributes should this release meet?</li>
          <li>- Jot them down, be precise and testable </li>
        </ol>
        <li>4. know WHERE:</li>
        <ol class="listStyleNone pl-4">
          <li>- On what environments will it be deployed on?</li>
          <li>- Are there new environments in focus this release?</li>
        </ol>
        <li>5. While surveying the system landscape, be observant/curious, jot down in NOTES:</li>
        <ol class="listStyleNone pl-4">
          <li>- Interesting observations, ideas</li>
          <li>- Questions (what-if, situations of use/abuse/exceptions, corner stuff)</li>
          <li>- Stuff to research/read-up-on</li>
          <li>- Technologies used, frameworks and other tools used</li>
          <li>- Interesting domain terms used, known issues/areas of improvement</li>
          <li>- Key business benefits intended and other similar applications/products</li>
        </ol>
      </ol>
    </ul>
  </div>
  <div class="row full-width card h-100 p-0 mb-2 cursorArrow"
    style="background-color: #ffffcc !important; overflow-x: auto;" *ngIf="activeSmartChecklist == 'la'">
    <ul>
      <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
      <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
      <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
      <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
      <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
      <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
      <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
      <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
      <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
      <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
      <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
      <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
      <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
      <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
      <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
      <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
      <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
      <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
      <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
      <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
      <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
      <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
      <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
      <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
      <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
      <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
      <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
      <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
    </ul>
  </div>
  <div class="row full-width card h-100 p-0 mb-2 cursorArrow"
    style="background-color: #ffffcc !important; overflow-x: auto;" *ngIf="activeSmartChecklist == 'Cl'">
    <ul>
      <h4>{{'checklist.navHeader' | translate}}</h4>
      <ol class="listStyleNone pl-2 overflowY">
        <li>1. {{'checklist.navSubHeader1' | translate}}</li>
        <li>2. {{'checklist.navSubHeader2' | translate}}</li>
        <ol class="listStyleNone pl-4">
          <li>a. {{'checklist.navSubHeader2Sub1' | translate}}</li>
          <li>b. {{'checklist.navSubHeader2Sub2' | translate}}</li>
          <li>c. {{'checklist.navSubHeader2Sub3' | translate}}</li>
        </ol>
        <li>3. {{'checklist.navSubHeader3' | translate}}</li>
        <ol class="listStyleNone pl-4">
          <li>a. {{'checklist.navSubHeader3Sub1' | translate}}</li>
          <li>b. {{'checklist.navSubHeader3Sub2' | translate}}</li>
          <li>c. {{'checklist.navSubHeader3Sub3' | translate}}</li>
        </ol>
        <li>4. {{'checklist.navSubHeader4' | translate}}</li>
        <ol class="listStyleNone pl-4">
          <li>a. {{'checklist.navSubHeader4Sub1' | translate}}</li>
          <li>b. {{'checklist.navSubHeader4Sub2' | translate}}</li>
          <li>c. {{'checklist.navSubHeader4Sub3' | translate}}</li>
          <li>d. {{'checklist.navSubHeader4Sub4' | translate}}</li>
          <li>e. {{'checklist.navSubHeader4Sub5' | translate}}</li>
        </ol>
        <li>5. {{'checklist.navSubHeader5' | translate}}</li>
        <ol class="listStyleNone pl-4">
          <li>a. {{'checklist.navSubHeader5Sub1' | translate}}</li>
          <li>b. {{'checklist.navSubHeader5Sub2' | translate}}</li>
          <li>c. {{'checklist.navSubHeader5Sub3' | translate}}</li>
        </ol>
      </ol>
    </ul>
  </div>
  <div class="row full-width leftPanelBottom card p-0 bg-black border-white" *ngIf="activeSmartChecklist == ''">
    <ul class="nav nav-tabs planner-nav-tabs" role="tablist">
      <li class="active leftPanelBottomTabList">
        <a data-toggle="tab" class="textClrWhite" [ngClass]="{ 'active':activeCockpitTab==='elements'}"
          (click)="shiftCockpitTabs('elements')">
          {{ 'planner.tasksPlus' | translate }}
        </a>
      </li>
      <li class="leftPanelBottomTabList">
        <a data-toggle="tab" class="textClrWhite" [ngClass]="{ 'active':activeCockpitTab==='design'}"
          (click)="shiftCockpitTabs('design')">
          {{ 'planner.readinessTab' | translate }}
        </a>
      </li>
      <li class="leftPanelBottomTabList">
        <a data-toggle="tab" class="textClrWhite" [ngClass]="{ 'active':activeCockpitTab==='evaluation'}"
          (click)="shiftCockpitTabs('evaluation')">
          {{ 'planner.evaluationTab' | translate }}
        </a>
      </li>
      <li class="leftPanelBottomTabList">
        <a data-toggle="tab" class="textClrWhite" [ngClass]="{ 'active':activeCockpitTab==='outcomes'}"
          (click)="shiftCockpitTabs('outcomes')">
          {{ 'planner.outcomesTab' | translate }}
        </a>
      </li>
    </ul>
    <div class="tab-content planner-nav-tab-content-height-bottom-part">
      <div class="tab-pane fade in" id="elements" [ngClass]="{ 'active':activeCockpitTab==='elements'}">
        <div class="planner-bottom-nav-tab-div-height">
          <table class="table table-striped planner-bottom-nav-tab-table-height mb-0 cursorArrow">
            <tbody class="align_center">
              <tr class="dark-mode-background-theme-colors">
                <th scope="row" class="pt-3 pb-3">
                  <div class="pb-2">
                    {{ 'planner.cockpitMyTasksDesc1' | translate }}
                    {{(modelData.tasks|mytasksTab:mytasksTabFilter:filterTypeCount)}}
                    {{ 'planner.cockpitMyTasksDesc2' | translate }}
                  </div>
                  <div class="pb-2">
                    ({{modelData.persona.length}}) {{ 'planner.Users' | translate }},
                    ({{modelData.modules.length}}) {{ 'planner.Modules' | translate }},
                    ({{modelData.listOfEUTs.length}}) EUT,
                    ({{detailsAttributeCount}}) Attr,
                    ({{modelData.listOfEnv.length}}) Env
                  </div>
                  <div class="pb-2">
                    ({{modelData.listOfEUTs|landscaperEntity:{eType:'TF'}:filterTypeCount}}) TF,
                    ({{modelData.listOfEUTs|landscaperEntity:{eType:'UR'}:filterTypeCount}}) UR,
                    ({{modelData.listOfEUTs|landscaperEntity:{eType:'BF'}:filterTypeCount}}) BF,
                    ({{modelData.listOfEUTs|landscaperEntity:{eType:'XX'}:filterTypeCount}}) XX
                  </div>
                  <div class="pb-2">
                    ({{modelData.cockpit.functionalScenarioCount}}) FT,
                    ({{modelData.cockpit.functionalScenarioPostiveCount}}) +ve,
                    ({{modelData.cockpit.functionalScenarioNegativeCount}}) -ve
                  </div>
                  <div>
                    ({{modelData.cockpit.nonFunctionalScenarioCount}}) NFT,
                    ({{modelData.cockpit.nonFunctionalScenarioPostiveCount}}) +ve,
                    ({{modelData.cockpit.nonFunctionalScenarioNegativeCount}}) -ve
                  </div>
                </th>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="tab-pane fade in" id="design" [ngClass]="{ 'active':activeCockpitTab==='design'}">
        <div class="planner-bottom-nav-tab-div-height">
          <table class="table table-striped planner-bottom-nav-tab-table-height mb-0 cursorArrow">
            <tbody class="align_center">
              <tr class="dark-mode-background-theme-colors">
                <th scope="row" class="pt-3 pb-3">
                  <div class="pb-2">
                    {{modelData.cockpit.readyEUTStatus}}%
                    {{ 'planner.EUTreadyForEval' | translate }}
                  </div>
                  <div class="pb-2">
                    {{modelData.cockpit.scenarioTFStatus}}%
                    ({{modelData.cockpit.scenarioTF}}) TF,
                    {{modelData.cockpit.scenarioBFStatus}}%
                    ({{modelData.cockpit.scenarioBF}}) BF,
                    {{modelData.cockpit.scenarioURStatus}}%
                    ({{modelData.cockpit.scenarioUR}}) UR,
                    {{modelData.cockpit.scenarioXXStatus}}%
                    ({{modelData.cockpit.scenarioXX}}) XX
                  </div>
                  <div>
                    {{modelData.cockpit.Attributestatus}}%
                    {{ 'planner.AttrreadyForEval' | translate }}
                  </div>
                </th>
              </tr>

            </tbody>
          </table>
        </div>
      </div>
      <div class="tab-pane fade in" id="evaluation" [ngClass]="{ 'active':activeCockpitTab==='evaluation'}">
        <div class="planner-bottom-nav-tab-div-height">
          <table class="table table-striped planner-bottom-nav-tab-table-height mb-0 cursorArrow">
            <tbody class="align_center">
              <tr class="dark-mode-background-theme-colors">
                <th scope="row" class="pt-3 pb-3">
                  <div class="pb-2">
                    {{ 'planner.howmuchEval' | translate }}
                  </div>
                  <div class="pb-2">
                    {{modelData.cockpit.EUTEvaluationStatus}}%
                    ({{modelData.cockpit.EUTEvaluationCount}})
                    {{ 'planner.EUTevaluated' | translate }}
                  </div>
                  <div class="pb-2">
                    {{modelData.cockpit.scenarioExecTFStatus}}%
                    ({{modelData.cockpit.scenarioExecTF}}) TF,
                    {{modelData.cockpit.scenarioExecBFStatus}}%
                    ({{modelData.cockpit.scenarioExecBF}}) BF,
                    {{modelData.cockpit.scenarioExecURStatus}}%
                    ({{modelData.cockpit.scenarioExecUR}}) UR,
                    {{modelData.cockpit.scenarioExecXXStatus}}%
                    ({{modelData.cockpit.scenarioExecXX}}) XX
                  </div>
                  <div>
                    {{modelData.cockpit.AttributeEvaluationStatus}}%
                    ({{modelData.cockpit.AttributeEvaluationCount}})
                    {{'planner.Attrevaluvated' | translate }}
                  </div>
                </th>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="tab-pane fade in" id="outcomes" [ngClass]="{ 'active':activeCockpitTab==='outcomes'}">
        <div class="planner-bottom-nav-tab-div-height">
          <table class="table table-striped planner-bottom-nav-tab-table-height mb-0 cursorArrow">
            <tbody class="align_center">
              <tr class="dark-mode-background-theme-colors">
                <th scope="row" class="pt-3 pb-3">
                  <div class="pb-2">
                    {{modelData.cockpit.EUTCleanStatus}}%
                    ({{modelData.cockpit.cleanEUTOutcome}})
                    {{ 'planner.EUTClean' | translate }}
                  </div>
                  <div class="pb-2">
                    {{modelData.cockpit.EUTCleanTFStatus}}%
                    ({{modelData.cockpit.cleanEUTTFOutcome}}) TF,
                    {{modelData.cockpit.EUTCleanBFStatus}}%
                    ({{modelData.cockpit.cleanEUTBFOutcome}}) BF,
                    {{modelData.cockpit.EUTCleanURStatus}}%
                    ({{modelData.cockpit.cleanEUTUROutcome}}) UR,
                    {{modelData.cockpit.EUTCleanXXStatus}}%
                    ({{modelData.cockpit.cleanEUTXXOutcome}}) XX
                  </div>
                  <div>
                    {{modelData.cockpit.AttriCleanStatus}}%
                    ({{modelData.cockpit.cleanAttriOutcome}})
                    {{ 'planner.AttrClean' | translate }}
                  </div>
                </th>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="tool-footer-height mt-2">
      <div class="text-align-right m-3 mt-4">
        <a [ngClass]="{notAllowed:modelData.persona.length==0 && modelData.listOfEUTs.length == 0 && modelData.listOfEnv.length == 0 }"
          *ngIf="activeCockpitTab === 'elements'"
          (click)="generateFullStatusDetails('elements');mainComponent.goToCockpit()">
          {{ 'planner.clickForMoreBtn' | translate }}
        </a>
        <a [ngClass]="{notAllowed:modelData.listOfEUTs.length == 0}" *ngIf="activeCockpitTab === 'design'"
          (click)="generateFullStatusDetails('design');mainComponent.goToCockpit()">
          {{ 'planner.clickForMoreBtn' | translate }}
        </a>
        <a [ngClass]="{notAllowed:modelData.listOfEUTs.length == 0}" *ngIf="activeCockpitTab === 'evaluation'"
          (click)="generateFullStatusDetails('evaluation');mainComponent.goToCockpit()">
          {{ 'planner.clickForMoreBtn' | translate }}
        </a>
        <a [ngClass]="{notAllowed:modelData.listOfEUTs.length == 0}" *ngIf="activeCockpitTab === 'outcomes'"
          (click)="generateFullStatusDetails('outcomes');mainComponent.goToCockpit()">
          {{ 'planner.clickForMoreBtn' | translate }}
        </a>
      </div>
    </div>
  </div>
</div>